import { createExternalRouteRef } from '@backstage/core-plugin-api';

export enum ExternalRoutesIds {
  entities = 'entities',
  factTablesCreate = 'factTablesCreate',
}

export const entitiesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entities,
  optional: true,
});

export const factTablesCreateRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.factTablesCreate,
  optional: true,
});
